(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-trust-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // The carousel's range, as the stylesheet's (live switches at 600px; see there).
    var MOBILE = '(max-width: 768px)';

    /*
      Flickity arrives via vendor-scripts-v11.js, which is deferred, and Shopify puts
      this bundle in the head — ahead of it. readyState is already 'interactive' while
      deferred scripts execute, so a readyState check runs this BEFORE Flickity exists
      and build() then returns silently, for good: the only retry is a breakpoint
      change. Wait for Flickity itself, else the load event, which is after every
      deferred script. Same helper as `pdp-complementary-products`.
    */
    function whenReady(callback) {
      if (typeof Flickity !== 'undefined' || document.readyState === 'complete') {
        callback();
        return;
      }
      window.addEventListener('load', callback, { once: true });
    }

    class CollectionTrustBar extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-trust-bar-track]');
        if (!this.track) return;

        this.flickity = null;
        this.query = window.matchMedia(MOBILE);
        this.onBreakpoint = this.onBreakpoint.bind(this);
        this.syncArrows = this.syncArrows.bind(this);

        this.prevButton = this.querySelector('[data-trust-bar-prev]');
        this.nextButton = this.querySelector('[data-trust-bar-next]');

        this.prevButton.addEventListener('click', () => {
          if (this.flickity) this.flickity.previous();
        });
        this.nextButton.addEventListener('click', () => {
          if (this.flickity) this.flickity.next();
        });

        whenReady(() => {
          this.onBreakpoint();
          // Safari < 14 only has the deprecated listener.
          if (this.query.addEventListener) {
            this.query.addEventListener('change', this.onBreakpoint);
          } else {
            this.query.addListener(this.onBreakpoint);
          }
        });
      }

      disconnectedCallback() {
        if (this.query.removeEventListener) {
          this.query.removeEventListener('change', this.onBreakpoint);
        } else {
          this.query.removeListener(this.onBreakpoint);
        }
        this.destroy();
      }

      onBreakpoint() {
        if (this.query.matches) {
          this.build();
        } else {
          this.destroy();
        }
      }

      build() {
        if (this.flickity || typeof Flickity === 'undefined') return;

        this.flickity = new Flickity(this.track, {
          cellSelector: '.collection-trust-bar__item',
          contain: true,
          draggable: true,
          pageDots: false,
          prevNextButtons: false,
          wrapAround: false,
        });

        this.flickity.on('select', this.syncArrows);
        this.syncArrows();
      }

      // Same shape as product-recommendations': the arrow dims at its end of the track.
      syncArrows() {
        if (!this.flickity) return;
        var index = this.flickity.selectedIndex;
        this.prevButton.disabled = index <= 0;
        this.nextButton.disabled = index >= this.flickity.slides.length - 1;
      }

      destroy() {
        if (!this.flickity) return;
        this.flickity.destroy();
        this.flickity = null;
        // Desktop hides the arrows rather than using them; don't leave them disabled.
        this.prevButton.disabled = false;
        this.nextButton.disabled = false;
      }
    }

    customElements.define('collection-trust-bar', CollectionTrustBar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    
  // YouTube serves a 120x90 grey placeholder instead of a 404 when a video has
  // no maxres thumbnail, so fall back to hqdefault on either signal.
  document.querySelectorAll('img[data-youtube-poster]').forEach(function (poster) {
    var downgrade = function () {
      if (poster.src.indexOf('maxresdefault') === -1) return;
      poster.src = poster.src.replace('maxresdefault', 'hqdefault');
    };

    poster.addEventListener('error', downgrade);
    poster.addEventListener('load', function () {
      if (poster.naturalWidth < 200) downgrade();
    });

    if (poster.complete && poster.naturalWidth < 200) downgrade();
  });

  // Results mode, in place. A filter applied from the drawer reloads only the products (theme.js fires
  // `collection:reloaded`, Back and Forward included), so the film, the overlaid header and the collection title row
  // are switched here: hidden while any filter is on, back once they are all cleared. A page loaded with a filter or
  // on page 2 never draws the hero at all (the Liquid above), so there is nothing to switch. While the filter drawer
  // is open the page behind it holds still (theme.js, theme.Collection), so the switch waits for it to close.
  (function () {
    var switchPending = false;

    function filtersOn() {
      var params = new URLSearchParams(window.location.search);
      for (var [key, value] of params) {
        if (key.indexOf('filter.') === 0 && value !== '') return true;
      }
      return false;
    }

    document.addEventListener('collection:reloaded', function () {
      var drawer = window.theme && window.theme.FilterDrawer;
      if (drawer && drawer.isOpen) {
        switchPending = true;
        return;
      }
      switchResultsMode();
    });

    document.addEventListener('drawerClose.FilterDrawer', function () {
      if (!switchPending) return;
      switchPending = false;
      switchResultsMode();
    });

    function switchResultsMode() {
      var heroes = document.querySelectorAll('.template-collection .hero-video');
      if (!heroes.length) return;

      var results = filtersOn();
      if (document.body.classList.contains('collection-results') === results) return;
      document.body.classList.toggle('collection-results', results);

      // Only where the header was drawn over the film to begin with (header.liquid's list of templates, kept in
      // data-overlay): a hero under a solid header, as on accessories, leaves the header alone both ways.
      var nav = window.theme && window.theme.headerNav;
      var siteHeader = document.getElementById('SiteHeader');
      if (nav && siteHeader && siteHeader.dataset.overlay === 'true') {
        if (results) nav.disableOverlayHeader();
        else if (nav.enableOverlayHeader) nav.enableOverlayHeader();

        // Over the film the toolbar's links are white on a clear band (theme.css .toolbar--transparent), which
        // disableOverlayHeader leaves alone: on the solid header they were white on white.
        document.querySelectorAll('#HeaderWrapper .toolbar').forEach(function (toolbar) {
          toolbar.classList.toggle('toolbar--transparent', !results);
        });
      }

      heroes.forEach(function (hero) {
        hero.querySelectorAll('video').forEach(function (video) {
          if (results) video.pause();
          else if (video.hasAttribute('data-play-near')) video.play().catch(function () {});
        });
      });
    }
  })();

  // A film the phone won't start by itself. theme.js plays it once it is near the screen,
  // and when the browser refuses (power saving, data saver, a browser setting) turns on the
  // video's own controls, a time bar over the hero: what a Samsung phone showed (Ayoob,
  // 2026-10-17). The poster stays instead, with nothing over it: a play button there was
  // taken out at his word (2026-10-18, "it looks bad"). The sound toggle still starts it.
  (function () {
    function wire(hero) {
      var video = hero.querySelector('video[data-play-near]');
      if (!video || hero.hasAttribute('data-still-when-refused')) return;
      hero.setAttribute('data-still-when-refused', '');

      function keepStill() {
        if (!video.hasAttribute('controls')) return;
        video.removeAttribute('controls');
        hero.classList.remove('video-interactable');
      }

      new MutationObserver(keepStill).observe(video, { attributes: true, attributeFilter: ['controls'] });
      keepStill();
    }

    document.querySelectorAll('.hero-video').forEach(wire);
    document.addEventListener('shopify:section:load', function (evt) {
      evt.target.querySelectorAll('.hero-video').forEach(wire);
    });
  })();

  // A film plays only while it is on screen or nearly (Ayoob, 2026-10-18: "pause them").
  // theme.js starts each film once it comes within 500px of the screen and never stops it,
  // so a film scrolled past played on and kept downloading: 27MB in 20s on a phone for the
  // landing page's two (../pj-visual-review/probe-film-scroll-away.mjs). It pauses once it
  // is more than 100px above the screen or 500px below it (the zone theme.js starts it in,
  // so a film started and then left behind below is caught too) and carries on from the
  // same frame when it comes back. A film this did not pause (not started yet, hidden by a
  // filter, refused by the phone) is left alone. Sound already follows the screen
  // (hero-sound, below).
  (function () {
    if (!('IntersectionObserver' in window)) return;

    function wire(hero) {
      var video = hero.querySelector('video[data-play-near]');
      if (!video || hero.hasAttribute('data-plays-on-screen')) return;
      hero.setAttribute('data-plays-on-screen', '');
      var pausedHere = false;

      new IntersectionObserver(function (entries) {
        var entry = entries[entries.length - 1];
        if (!entry.isIntersecting) {
          if (!video.paused) {
            video.pause();
            pausedHere = true;
          }
          return;
        }
        if (!pausedHere) return;
        pausedHere = false;
        var attempt = video.play();
        if (attempt && typeof attempt.catch === 'function') attempt.catch(function () {});
      }, { rootMargin: '100px 0px 500px 0px' }).observe(hero);
    }

    document.querySelectorAll('.hero-video').forEach(wire);
    document.addEventListener('shopify:section:load', function (evt) {
      evt.target.querySelectorAll('.hero-video').forEach(wire);
    });
  })();

  // Hero video sound. A custom element, so a section the theme editor re-renders is
  // wired and torn down by the browser's own lifecycle. When sound may actually play is
  // theme.videoSound's business (snippets/video-sound.liquid); it is looked up when it
  // is needed, never while the page loads, so script order does not matter.
  (function () {
    if (customElements.get('hero-sound')) return;

    function videoSound() {
      return window.theme && window.theme.videoSound;
    }

    class HeroSound extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.onPageShow = this.onPageShow.bind(this);
        this.update = this.update.bind(this);
        this.yieldSound = this.yieldSound.bind(this);
      }

      connectedCallback() {
        this.hero = this.closest('.video-parent-section');
        this.video = this.hero && this.hero.querySelector('video[data-type="mp4"]');
        if (!this.video) return;

        // The section's Volume setting; muting leaves it alone. iPhones and iPads ignore
        // it (their volume buttons rule). Clamped: an out-of-range value would throw.
        var volume = (parseFloat(this.dataset.volume) || 100) / 100;
        this.video.volume = Math.min(1, Math.max(0, volume));

        // wantSound is what the visitor has asked for: it starts at the section's "Start
        // with sound on" setting and follows the button from then on. Whether they
        // actually HEAR it also needs the video on screen, the tab visible, the
        // browser's permission and no other video holding the sound.
        this.soundDefault = this.dataset.startUnmuted === 'true';
        this.wantSound = this.soundDefault;
        this.onScreen = false;
        this.yielded = false;
        this.cancelWait = null;
        this.started = false; // has playback really begun? (see update)

        // Listening on the element rather than the button: it still works if this runs
        // before the button inside has been parsed.
        this.addEventListener('click', this.onClick);
        document.addEventListener('visibilitychange', this.update);
        window.addEventListener('pageshow', this.onPageShow);
        this.observe();
        this.render();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        document.removeEventListener('visibilitychange', this.update);
        window.removeEventListener('pageshow', this.onPageShow);
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }
        this.stopWaiting();
        var sound = videoSound();
        if (sound && this.video) sound.release(this.video);
      }

      // Sound follows the video on screen. It starts once half the video is in view and
      // stops once all but a fifth has scrolled away, so reading the text just below
      // does not cut it, and a video the visitor cannot see never plays sound, nor keeps
      // playing it with its mute button scrolled out of reach. For a video taller than
      // the window, filling half the window counts as half in view.
      observe() {
        var self = this;
        if (!('IntersectionObserver' in window)) {
          this.onScreen = true;
          this.update();
          return;
        }

        var steps = [];
        for (var i = 0; i <= 10; i++) steps.push(i / 10);

        this.observer = new IntersectionObserver(function (entries) {
          var entry = entries[entries.length - 1];
          var windowHeight = window.innerHeight || document.documentElement.clientHeight;
          var seen = Math.max(entry.intersectionRatio, windowHeight ? entry.intersectionRect.height / windowHeight : 0);
          var next = self.onScreen ? seen > 0.2 : seen >= 0.5;
          if (next === self.onScreen) return;
          self.onScreen = next;
          if (!self.onScreen) self.yielded = false;
          self.update();
        }, { threshold: steps });

        this.observer.observe(this.hero);
      }

      onClick(event) {
        if (!event.target.closest('.hero__sound')) return;

        // A muted video means they are asking for sound, whether they muted it, the
        // browser did, or another video took it. The click is also the browser's
        // permission, and plays a video whose autoplay was refused (Low Power Mode).
        this.wantSound = this.video.muted;
        this.yielded = false;
        if (this.wantSound) this.onScreen = true; // they are looking at it: they just pressed it
        this.update(true);
      }

      // Back/forward (bfcache) restores the page exactly as it was left; start over from
      // the section's default, as a fresh visit would.
      onPageShow(event) {
        if (!event.persisted) return;
        this.wantSound = this.soundDefault;
        this.yielded = false;
        this.update();
      }

      // Another video claimed the sound.
      yieldSound() {
        this.yielded = true;
        this.update();
      }

      stopWaiting() {
        if (this.cancelWait) this.cancelWait();
        this.cancelWait = null;
      }

      // `gesture` is true only when a visitor's click or tap is asking. Listeners call this
      // with an event, which counts as automatic.
      update(gesture) {
        var sound = videoSound();
        if (!sound || !this.isConnected) return;

        if (!this.wantSound || !this.onScreen || this.yielded || document.hidden) {
          this.video.muted = true;
          sound.release(this.video);
          this.render();
          return;
        }
        if (!this.video.muted) return;

        var self = this;

        // theme.js starts the muted autoplay with its own play(), and answers a rejected one
        // by giving the hero native controls. Asking for sound while that play() is still
        // pending makes the browser pause the video, which rejects it: measured, controls on
        // 2 loads in 4, because here theme.js runs first (on live the sound request does).
        // `paused` cannot tell — play() clears it at once — so an automatic request waits
        // for the `playing` event, then one task more for theme.js's promise to settle. A
        // visitor's click goes straight on: it is the browser's permission, and also what
        // starts a video whose autoplay was refused.
        if (gesture !== true && !this.started) {
          if (!this.video.paused && this.video.readyState > 2 && this.video.currentTime > 0) {
            this.started = true;
          } else {
            if (!this.waitingToPlay) {
              this.waitingToPlay = true;
              this.video.addEventListener('playing', function () {
                self.started = true;
                self.waitingToPlay = false;
                setTimeout(function () { self.update(); }, 0);
              }, { once: true });
            }
            return;
          }
        }

        sound.play(this.video).then(function (allowed) {
          if (!self.isConnected) {
            sound.release(self.video);
            return;
          }
          self.render();
          if (!allowed) {
            // Held muted until the visitor interacts: try again at the first click or
            // tap. The button acts for itself, so its own clicks are left out.
            if (!self.cancelWait) {
              self.cancelWait = sound.afterInteraction(function () {
                self.cancelWait = null;
                self.update(true);
              }, self);
            }
          } else if (!self.video.muted) {
            self.stopWaiting();
            sound.claim(self.video, self.yieldSound);
          }
        });
        this.render();
      }

      // The button shows what is heard, not what was asked for: a video the browser is
      // holding muted must offer "Unmute", or pressing it would do the opposite.
      render() {
        var button = this.querySelector('.hero__sound');
        if (!button) return;
        var soundOn = !this.video.muted;
        button.setAttribute('aria-pressed', soundOn ? 'true' : 'false');
        button.setAttribute('aria-label', soundOn ? button.dataset.labelMute : button.dataset.labelUnmute);
      }
    }

    customElements.define('hero-sound', HeroSound);
  })();

  // Hero scroll cue. Delegated from the document so a section the theme editor
  // re-renders is wired without anything having to run again.
  (function () {
    var running = null;

    // Every frame has to land instantly. The two-argument scrollTo still obeys the
    // theme's html{scroll-behavior:smooth}, so each frame would kick off its own smooth
    // scroll and fight this tween. behavior:'instant' opts out per call, which is safer
    // than flipping the property on <html> — that stays flipped if a frame never
    // arrives, disabling smooth scrolling for the whole page.
    var scrollToY;
    try {
      window.scrollTo({ top: window.pageYOffset, behavior: 'instant' });
      scrollToY = function (y) { window.scrollTo({ top: y, behavior: 'instant' }); };
    } catch (e) {
      scrollToY = function (y) { window.scrollTo(0, y); };
    }

    function easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    // Hand-rolled rather than scrollIntoView({behavior:'smooth'}). Native smooth
    // scrolling — the options-object form AND html{scroll-behavior:smooth} — is
    // silently downgraded to an instant jump for anyone with "reduce motion" set at OS
    // or browser level. This is a short, click-initiated transition that exists to show
    // where you have been taken, so it animates regardless. The looping bob on the
    // arrow is a different matter and stays behind the prefers-reduced-motion query in
    // the CSS above.
    function animateScrollTo(targetY) {
      var startY = window.pageYOffset;
      var delta = targetY - startY;
      if (Math.abs(delta) < 2) return;

      var duration = Math.min(900, Math.max(450, Math.abs(delta)));
      var startTime = null;

      function finish() {
        running = null;
        window.removeEventListener('wheel', cancel);
        window.removeEventListener('touchstart', cancel);
        window.removeEventListener('keydown', cancel);
      }

      // Never fight someone who has taken the scroll over themselves.
      function cancel() {
        if (running) cancelAnimationFrame(running);
        finish();
      }

      window.addEventListener('wheel', cancel, { passive: true });
      window.addEventListener('touchstart', cancel, { passive: true });
      window.addEventListener('keydown', cancel);

      function step(timestamp) {
        if (startTime === null) startTime = timestamp;
        var progress = Math.min((timestamp - startTime) / duration, 1);
        scrollToY(startY + delta * easeInOutCubic(progress));

        if (progress < 1) {
          running = requestAnimationFrame(step);
        } else {
          finish();
        }
      }

      running = requestAnimationFrame(step);
    }

    document.addEventListener('click', function (event) {
      var cue = event.target.closest('.hero__scroll-cue');
      if (!cue) return;

      var hero = cue.closest('.video-parent-section');
      if (!hero) return;

      // Skip zero-height sections on the way down. On the collection templates the next
      // one is collection-header, which renders nothing but the empty div its own
      // section JS needs when the hero is carrying the title.
      var section = hero.closest('.shopify-section') || hero.parentElement;
      var next = section && section.nextElementSibling;
      while (next && next.offsetHeight === 0) {
        next = next.nextElementSibling;
      }

      var targetY = next
        ? next.getBoundingClientRect().top + window.pageYOffset
        : hero.getBoundingClientRect().bottom + window.pageYOffset;

      animateScrollTo(targetY);
    });

    // Hide the cue once the page is moving.
    function onScroll() {
      var scrolled = window.pageYOffset > 40 ? 'true' : 'false';
      document.querySelectorAll('.hero--has-scroll-cue').forEach(function (hero) {
        hero.dataset.scrolled = scrolled;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  /*
    What the drawer's script does for its lines, for the page's: Remove in place, and the title's
    count kept up to date. Delegated from the form, which stays while theme.js rebuilds the lines.
  */
  (() => {
    const init = () => {
      const form = document.getElementById('CartPageForm');
      if (!form || form.dataset.controls) return;
      form.dataset.controls = 'true';

      const products = form.querySelector('[data-products]');
      const count = form.closest('.cart-page')?.querySelector('[data-cart-page-count]');

      // "3 items", from the count the rebuilt lines carry (templates/cart.ajax.liquid).
      if (products && count) {
        new MutationObserver(() => {
          const items = products.querySelector('[data-count-label]');
          if (items) count.textContent = items.dataset.countLabel;
        }).observe(products, { childList: true });
      }

      /*
        Remove sets the line's quantity to 0 through its own box, so theme.js changes the cart,
        rebuilds the lines and announces it, as for the minus button. Without the box (or without
        this script) the link still works: it reloads the page without the line.
      */
      form.addEventListener('click', (event) => {
        const remove = event.target.closest('[data-cart-remove]');
        if (!remove) return;

        const line = remove.closest('[data-key]');
        const input = line?.querySelector('input[data-id]');
        if (!input) return;

        event.preventDefault();
        line.classList.add('is-removing');
        input.value = '0';
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    /*
      Kimonix serves an alternative collection under the original URL; this tags the
      address bar so its own analytics can tell which variant was seen. Liquid has
      already swapped the collection server-side — this is bookkeeping, not routing.
    */
    class KimonixMask extends HTMLElement {
      connectedCallback() {
        var target = this.dataset.kimonixTarget;
        if (!target || !('URLSearchParams' in window)) return;

        var url = new URL(window.location);
        url.searchParams.set('kmnx-target', target);
        history.replaceState(null, '', url);
      }
    }

    customElements.define('kimonix-mask', KimonixMask);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPdpVideo(wrapper) {
      var container = wrapper.querySelector('.pdp-video');
      var videos = Array.prototype.slice.call(wrapper.querySelectorAll('.pdp-video__player'));
      var toggle = wrapper.querySelector('.pdp-video__toggle');
      var sound = wrapper.querySelector('.pdp-video__sound');
      if (!videos.length || !container) return;
      if (container.dataset.pdpVideoInit === '1') return;
      container.dataset.pdpVideoInit = '1';

      // Labels are rendered by Liquid so they stay translatable.
      var strings = {
        play: container.dataset.labelPlay,
        pause: container.dataset.labelPause,
        mute: container.dataset.labelMute,
        unmute: container.dataset.labelUnmute
      };
      var desktopVideo = wrapper.querySelector('.pdp-video__player--desktop') || videos[0];
      var mobileVideo = wrapper.querySelector('.pdp-video__player--mobile');
      var mobileMql = window.matchMedia('(max-width: 749px)');

      // Which video is on-screen for the current viewport. The other is display:none
      // via CSS, so we never want to play it.
      function getActiveVideo() {
        return mobileVideo && mobileMql.matches ? mobileVideo : desktopVideo;
      }

      // Nothing loads for this section until the shopper starts scrolling (Ayoob,
      // 2026-10-13). It sits about a screen below the buy box, so warming it two screens
      // ahead started its video as every product page opened: 9-10MB in Chrome before a
      // single scroll. From the first scroll the poster and the video's buffer start, as
      // before, while the shopper is still on the way down, so the video doesn't look slow
      // when it arrives. A window tall enough to show it at once loads it as it plays.
      var scrolled = window.scrollY > 0;
      function onFirstScroll() {
        if (window.scrollY <= 0) return;
        scrolled = true;
        window.removeEventListener('scroll', onFirstScroll);
        showPoster();
        warmActiveVideo();
      }
      if (!scrolled) window.addEventListener('scroll', onFirstScroll, { passive: true });

      // Right-sized poster, mobile gets a lighter image, and only on the video this width
      // shows, once the section is within two screens (below). Set on both videos as the
      // page opened, a desktop fetched the phone video's 200KB poster it never shows.
      var nearScreen = false;
      function showPoster() {
        var video = getActiveVideo();
        if (!(nearScreen && scrolled) && !inView) return;
        if (!video || video.dataset.posterSet === '1') return;
        var posterMobile = video.getAttribute('data-poster-mobile');
        var posterDesktop = video.getAttribute('data-poster-desktop');
        if (!posterMobile && !posterDesktop) return;
        video.dataset.posterSet = '1';
        video.poster = (window.innerWidth <= 749 ? posterMobile : posterDesktop) || posterDesktop || posterMobile;
      }

      if ('IntersectionObserver' in window) {
        var posterMargin = Math.max(1200, Math.round(window.innerHeight * 2)) + 'px';
        var posterObserver = new IntersectionObserver(
          function (posterEntries) {
            if (!posterEntries.some(function (posterEntry) { return posterEntry.isIntersecting; })) return;
            nearScreen = true;
            showPoster();
            posterObserver.disconnect();
          },
          { rootMargin: posterMargin + ' 0px ' + posterMargin + ' 0px' }
        );
        posterObserver.observe(container);
      } else {
        nearScreen = true;
        showPoster();
      }

      // The section's Volume setting, on both orientations; muting leaves it alone.
      // iPhones and iPads ignore it (their volume buttons rule). Clamped: an out-of-range
      // value would throw.
      var volume = Math.min(1, Math.max(0, (parseFloat(container.dataset.volume) || 100) / 100));
      videos.forEach(function (video) {
        video.volume = volume;
      });

      var saveData = navigator.connection && navigator.connection.saveData;
      var userPaused = false;
      var inView = false;
      var inWarmZone = false;

      // What the visitor has asked for: starts at "Start with sound on" and follows the
      // button. The browser may still hold it muted (snippets/video-sound.liquid). Read
      // from the markup: this script initialises every wrapper on the page.
      var soundDefault = container.dataset.startUnmuted === 'true';
      var wantSound = soundDefault;
      var cancelWait = null;

      // Looked up when needed, never while the page loads, so script order does not matter.
      function videoSound() {
        return window.theme && window.theme.videoSound;
      }

      // Sound follows the viewer's choice, but only the on-screen video carries it — the
      // hidden (wrong-orientation) one stays muted so we never play audio twice. This only
      // ever mutes: unmuting goes through tryPlay(), which can take the browser's refusal.
      // The button shows what is heard, not what was asked for.
      function applySound() {
        var active = getActiveVideo();
        videos.forEach(function (video) {
          if (video !== active || !wantSound) video.muted = true;
        });
        var soundOn = !active.muted;
        container.dataset.sound = soundOn ? 'on' : 'off';
        if (sound) {
          sound.setAttribute('aria-pressed', soundOn ? 'true' : 'false');
          sound.setAttribute('aria-label', soundOn ? strings.mute : strings.unmute);
        }
      }

      // Sound refused until the visitor interacts: retry at their first click or tap.
      // Taps on the video itself are its play/pause toggle and act for themselves —
      // resuming from it asks for sound anyway, through tryPlay().
      function waitForInteraction() {
        var helper = videoSound();
        if (cancelWait || !helper) return;
        cancelWait = helper.afterInteraction(function () {
          cancelWait = null;
          if (wantSound && inView && !userPaused && !document.hidden) tryPlay();
        }, container);
      }

      function setPaused(paused) {
        container.dataset.paused = paused ? 'true' : 'false';
        if (toggle) {
          toggle.setAttribute('aria-label', paused ? strings.play : strings.pause);
        }
      }

      // Keep the hidden video (wrong orientation for this viewport) stopped.
      function pauseInactive() {
        videos.forEach(function (video) {
          if (video !== getActiveVideo() && !video.paused) video.pause();
        });
      }

      function tryPlay() {
        pauseInactive();
        applySound();
        showPoster();
        var active = getActiveVideo();
        var helper = videoSound();
        if (wantSound && active.muted && helper) {
          helper.play(active).then(function (allowed) {
            applySound();
            if (!allowed) waitForInteraction();
          });
          return;
        }
        var playPromise = active.play();
        if (playPromise !== undefined) {
          playPromise.catch(function () {
            setPaused(true);
          });
        }
      }

      // Buffer-warming: fetch (not play) the on-screen video ahead of the viewport so it
      // starts without a visible wait. Only the current breakpoint's video is warmed —
      // the hidden (wrong-orientation) one stays cold. Guarded so each video warms once.
      function warmActiveVideo() {
        var video = getActiveVideo();
        if (!inWarmZone || !scrolled || !video || video.dataset.warmed === '1') return;
        video.dataset.warmed = '1';
        try {
          video.preload = 'auto';
          video.load();
        } catch (e) {}
      }

      // Only reflect state for the on-screen video, so pausing the hidden one doesn't
      // flip the play/pause overlay.
      videos.forEach(function (video) {
        video.addEventListener('play', function () {
          if (video === getActiveVideo()) setPaused(false);
        });
        video.addEventListener('pause', function () {
          if (video === getActiveVideo()) setPaused(true);
        });
      });

      if (toggle) {
        toggle.addEventListener('click', function () {
          var video = getActiveVideo();
          if (video.paused) {
            userPaused = false;
            tryPlay();
          } else {
            userPaused = true;
            video.pause();
          }
        });
      }

      if (sound) {
        sound.addEventListener('click', function () {
          // A muted video means they are asking for sound — whether they muted it or the
          // browser did.
          wantSound = getActiveVideo().muted;
          applySound();
          // "Unmute and listen": turning sound on also starts a paused video.
          if (wantSound) {
            userPaused = false;
            tryPlay();
          }
        });
      }

      // Back/forward (bfcache) restores the page exactly as it was left; start over from
      // the section's default, as a fresh visit would.
      window.addEventListener('pageshow', function (e) {
        if (!e.persisted) return;
        wantSound = soundDefault;
        applySound();
        if (wantSound && inView && !userPaused && !document.hidden) tryPlay();
      });

      // When the viewport crosses the mobile breakpoint, hand playback to the
      // now-visible video and stop the one that just got hidden.
      function handleBreakpointChange() {
        pauseInactive();
        applySound();
        showPoster();
        warmActiveVideo();
        if (inView && !userPaused && !saveData) tryPlay();
      }
      if (mobileMql.addEventListener) {
        mobileMql.addEventListener('change', handleBreakpointChange);
      } else if (mobileMql.addListener) {
        mobileMql.addListener(handleBreakpointChange);
      }

      // Start paused — playback is driven by scroll position via IntersectionObserver.
      setPaused(true);
      applySound();

      // Don't autoplay with Data Saver on — tap-to-play still works.
      if (saveData) return;

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              inView = entry.isIntersecting;
              if (entry.isIntersecting) {
                if (userPaused) return; // honour the user's manual pause
                tryPlay();
              } else {
                pauseInactive();
                var active = getActiveVideo();
                if (!active.paused) active.pause();
              }
            });
          },
          { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
        );
        observer.observe(container);

        // A wider second observer warms the buffer ~2 screens before the video reaches
        // the viewport (fetch only, never play), so scrolling to it doesn't stall. Warms
        // the current-breakpoint video once; handleBreakpointChange() re-warms the newly
        // visible one after a rotate. Inside the saveData guard, so Data Saver skips it.
        var warmMargin = Math.max(1200, Math.round(window.innerHeight * 2));
        var warmObserver = new IntersectionObserver(
          function (warmEntries) {
            warmEntries.forEach(function (warmEntry) {
              if (!warmEntry.isIntersecting) return;
              inWarmZone = true;
              warmActiveVideo();
              warmObserver.disconnect();
            });
          },
          { rootMargin: '0px 0px ' + warmMargin + 'px 0px' }
        );
        warmObserver.observe(container);

        // Pause when the tab is hidden to save data/battery; resume if still in view.
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) {
            videos.forEach(function (video) {
              if (!video.paused) video.pause();
            });
          } else if (inView && !userPaused) {
            tryPlay();
          }
        });
      } else {
        tryPlay();
      }
    }

    function initAll() {
      document.querySelectorAll('.pdp-video-wrapper').forEach(initPdpVideo);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Re-init when Shopify reloads the section (theme editor).
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('.pdp-video-wrapper')) {
        initAll();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-workshop-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /*
      Live's Swiper autoplay delay. Swiper starts it when a fade ends, so a photo holds
      for this long between fades; the fade itself is the slides' CSS transition.
    */
    var HOLD_MS = 1500;

    function initWorkshopSlides(slides) {
      if (slides.dataset.workshopSlidesInit === '1') return;
      slides.dataset.workshopSlidesInit = '1';

      var items = slides.querySelectorAll('.workshop-hero__slide');
      if (items.length < 2) return;

      var fadeMs = parseFloat(getComputedStyle(items[0]).transitionDuration) * 1000 || 0;
      var index = 0;

      function advance() {
        // A section the theme editor has replaced: stop.
        if (!slides.isConnected) return;

        var leaving = items[index];
        index = (index + 1) % items.length;
        var entering = items[index];

        // Back to where it slides in from — with two photos it is still where it left.
        entering.classList.add('is-snapping');
        entering.classList.remove('is-leaving');
        void entering.offsetWidth;
        entering.classList.remove('is-snapping');

        items.forEach(function (item) {
          if (item !== leaving) item.classList.remove('is-leaving');
        });
        leaving.classList.remove('is-active');
        leaving.classList.add('is-leaving');
        entering.classList.add('is-active');

        setTimeout(advance, fadeMs + HOLD_MS);
      }

      setTimeout(advance, HOLD_MS);
    }

    function initAll() {
      document.querySelectorAll('[data-workshop-slides]').forEach(initWorkshopSlides);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Re-init when Shopify reloads the section (theme editor).
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('[data-workshop-slides]')) {
        initAll();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-detailing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /*
      The strip is a carousel only where the stylesheet marks it: ::after content
      'flickity', at <=768px. The theme's Flickity build has no watchCSS, so a
      watchCSS option is silently ignored and the carousel would switch on at every
      width — on desktop it collapsed the 3-up row into a 0px-tall viewport. So the
      marker is read here instead: build the carousel when it appears, destroy it
      when it goes, and leave the plain row alone everywhere else. The breakpoint
      still lives only in the stylesheet.

      No arrows (Ayoob, 2026-10-18; live has them): the next photo peeks in from the
      edge, and on a phone the row is moved by finger.
    */
    var carousels = new WeakMap();

    function wantsCarousel(el) {
      return getComputedStyle(el, '::after').content.indexOf('flickity') !== -1;
    }

    function sync(el) {
      if (typeof Flickity === 'undefined' || !window.theme || !theme.Slideshow) return;
      var carousel = carousels.get(el);

      if (wantsCarousel(el)) {
        if (!carousel) {
          carousels.set(el, new theme.Slideshow(el, {
            cellAlign: 'left',
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            wrapAround: false,
            autoPlay: false
          }));
        }
      } else if (carousel) {
        carousel.destroy();
        carousels.delete(el);
      }
    }

    function syncAll() {
      document.querySelectorAll('[data-detailing-carousel]').forEach(sync);
    }

    /*
      Not "loading ? wait : run now". This bundle is a deferred script that the page
      lists BEFORE vendor-scripts (Flickity) and theme.js (theme.Slideshow), so it runs
      while readyState is already 'interactive' — "run now" found no Flickity, bailed,
      and the strip stayed an unclipped flex row 825px wide on a 390px phone.
      DOMContentLoaded fires after every deferred script has run; load covers a late
      injection. sync() leaves an element that is already in the right state alone.
    */
    if (document.readyState === 'complete') {
      syncAll();
    } else {
      document.addEventListener('DOMContentLoaded', syncAll);
      window.addEventListener('load', syncAll);
    }

    // Crossing the breakpoint either way, at most once per frame.
    var resizeQueued = false;
    window.addEventListener('resize', function () {
      if (resizeQueued) return;
      resizeQueued = true;
      requestAnimationFrame(function () {
        resizeQueued = false;
        syncAll();
      });
    });

    // Re-init when Shopify reloads the section (theme editor).
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('[data-detailing-carousel]')) {
        syncAll();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function () {
    var CELL_SELECTOR = '.grid__item';

    var instances = new WeakMap();

    /*
      Flickity arrives via vendor-scripts-v11.js, which is deferred, and Shopify
      decides for itself where this bundle lands relative to it. Deferred scripts
      have all run by DOMContentLoaded, so waiting for it makes the order moot
      rather than betting on it — including when a cached recommendations response
      comes back before the page has finished parsing.
    */
    function whenReady(callback) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback, { once: true });
      } else {
        callback();
      }
    }

    function buildCarousel(scope) {
      var carousel = scope.querySelector('[data-recommendations-carousel]');
      if (!carousel || instances.has(carousel)) return;
      if (typeof Flickity === 'undefined') return;
      if (carousel.querySelectorAll(CELL_SELECTOR).length < 2) return;

      // On the title's line (snippets/carousel-arrows.liquid), which never comes by fetch.
      var section = carousel.closest('.product-recommendations-section');
      var arrows = section && section.querySelector('[data-carousel-arrows]');
      var prev = arrows && arrows.querySelector('[data-step="-1"]');
      var next = arrows && arrows.querySelector('[data-step="1"]');

      /*
        Flickity direct rather than theme.Slideshow, to match the complementary
        carousel and to skip theme.Slideshow's per-instance window resize listener,
        which its destroy() never removes.
      */
      var flickity = new Flickity(carousel, {
        cellSelector: CELL_SELECTOR,
        cellAlign: 'left',
        contain: true,
        groupCells: true,
        pageDots: false,
        prevNextButtons: false,
        wrapAround: false,
        setGallerySize: true,
        rightToLeft: Boolean(window.theme && theme.config && theme.config.rtl)
      });

      // The arrows show while the cards run to more than one page, each greyed at its end.
      function syncArrows() {
        var last = flickity.slides.length - 1;
        var index = flickity.selectedIndex;
        if (arrows) arrows.hidden = last < 1;
        if (prev) prev.disabled = index <= 0;
        if (next) next.disabled = index >= last;
      }

      if (prev) prev.addEventListener('click', function () { flickity.previous(); });
      if (next) next.addEventListener('click', function () { flickity.next(); });

      flickity.on('select', syncArrows);
      syncArrows();

      // Flickity regroups the cards into pages on a resize, after a short wait of its own.
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(syncArrows, 250);
      }, { passive: true });

      instances.set(carousel, flickity);
    }

    // Algorithmic results arrive later — the element fetches them and says so.
    document.addEventListener('recommendations:loaded', function (event) {
      var section = event.detail && event.detail.section;
      if (!section || section.classList.contains('hide')) return;
      whenReady(function () {
        buildCarousel(section);
      });
    });

    // A _related_ tag renders its collection server-side, so there's nothing to wait for.
    whenReady(function () {
      document.querySelectorAll('.product-recommendations-section').forEach(buildCarousel);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
